import {ValidateFunc} from '@/project'

const isBizRNum: ValidateFunc = (number: any): boolean => {
  if(!number) return false
  const checkId = [1, 3, 7, 1, 3, 7, 1, 3, 5, 1]
  let chkSum = 0
  let c2

  for(let i = 0; i <= 7; i += 1) {
    chkSum += checkId[i] * number.charAt(i)
  }
  c2 = '0' + checkId[8] * number.charAt(8)
  c2 = c2.substring(c2.length - 2, c2.length)
  chkSum += Math.floor(c2.charAt(0)) + Math.floor(c2.charAt(1))
  const remander = (10 - chkSum % 10) % 10

  if(Math.floor(number.charAt(9)) === remander && number.length === 10) {
    return true
  } // OK!
  return false
}

export default isBizRNum
